import React, { useEffect, useRef } from "react";
import "./HomePage.css";
import homevideo from "../../Assets/HomeVideo/homevideo.mp4";

const HomePage = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const words = contentRef.current?.querySelectorAll(".alpha_home_pg_word");
    words?.forEach((word, i) => {
      word.style.animationDelay = `${0.2 + i * 0.12}s`;
    });
  }, []);

  return (
    <div className="alpha_home_pg_container" id="home">

      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="alpha_home_pg_video"
      >
        <source src={homevideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Gradient Overlay */}
      <div className="alpha_home_pg_overlay" />

      {/* Hero Content */}
      <div className="alpha_home_pg_content" ref={contentRef}>

        {/* Tag Pill */}
        <span className="alpha_home_pg_tag alpha_home_pg_word">
          Medical Coding &amp; Billing Excellence
        </span>

        {/* Main Title */}
        <h1 className="alpha_home_pg_title">
          <span className="alpha_home_pg_title_line">
            <span className="alpha_home_pg_word">We&nbsp;</span>
            <span className="alpha_home_pg_word">Power&nbsp;</span>
            <span className="alpha_home_pg_word">Practices.</span>
          </span>
          <span className="alpha_home_pg_title_line alpha_home_pg_title_accent">
            <span className="alpha_home_pg_word">We&nbsp;</span>
            <span className="alpha_home_pg_word">Train&nbsp;</span>
            <span className="alpha_home_pg_word">Professionals.</span>
          </span>
        </h1>

        {/* Description */}
        <p className="alpha_home_pg_desc alpha_home_pg_word">
          Alphaingen is a leading medical coding &amp; billing center and a trusted
          training institution — preparing the next generation of certified
          professionals in healthcare revenue cycle management.
        </p>

        {/* CTA Buttons */}
        <div className="alpha_home_pg_cta alpha_home_pg_word">
          <a href="#programme" className="alpha_home_pg_btn_primary">
            Explore Services
          </a>
          <a href="#endroll" className="alpha_home_pg_btn_secondary">
            Start Training
          </a>
        </div>

      </div>


    </div>
  );
};

export default HomePage;